import axios from 'utils/axios';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  applicationList: [],
  error: null,
  isLoading: true,
};

const slice = createSlice({
  name: 'applications',
  initialState,
  reducers: {
    applicationsStartLoading(state) {
      state.isLoading = true;
    },

    applicationsHasError(state, action) {
      state.isLoading = false;
      state.error = action.payload?.error ?? action.payload;
      state.applicationList = [];
    },

    applicationsSuccess(state, action) {
      state.isLoading = false;
      state.applicationList = Array.isArray(action.payload) ? action.payload : [];
      state.error = null;
    },

    /** PATCH commerce-channel-config returns full application row — merge so UI updates before GET completes */
    applicationCommerceChannelMerged(state, action) {
      const row = action.payload;
      if (!row || row.id == null) {
        return;
      }
      const idStr = String(row.id);
      const idx = state.applicationList.findIndex((a) => String(a.id) === idStr);
      if (idx !== -1) {
        state.applicationList[idx] = { ...state.applicationList[idx], ...row };
      }
    },
  },
});

export default slice.reducer;

export function getApplications(customerId) {
  return async (dispatch) => {
    dispatch(slice.actions.applicationsStartLoading());
    try {
      const response = await axios.get(`/customers/${customerId}/applications`);
      dispatch(slice.actions.applicationsSuccess(response));
    } catch (error) {
      dispatch(slice.actions.applicationsHasError(error));
    }
  };
}

export function createApplication(customerId, payload) {
  const { name, logo } = payload;
  return async (dispatch) => {
    const application = await axios.post(`/customers/${customerId}/applications`, {
      customerId,
      name,
      logo: logo ?? '',
    });
    await dispatch(getApplications(customerId));
    return application;
  };
}

export function patchApplicationCommerceChannelConfig(customerId, applicationId, payload) {
  const body = Array.isArray(payload) ? { channels: payload } : payload;
  return async (dispatch) => {
    const updated = await axios.patch(
      `/customers/${customerId}/applications/${applicationId}/commerce-channel-config`,
      body,
    );
    dispatch(slice.actions.applicationCommerceChannelMerged(updated));
    await dispatch(getApplications(customerId));
  };
}
